import * as Dropdown from '@radix-ui/react-dropdown-menu'
import { keyframes, styled } from 'style'

const fadeInTop = keyframes({
  from: {
    opacity: 0,
    transform: 'translateY(-8px)',
  },
  to: {
    opacity: 1,
    transform: 'translateY(0)',
  },
})

const fadeOutTop = keyframes({
  from: {
    opacity: 1,
  },
  to: {
    opacity: 0,
    transform: 'translateY(-8px)',
  },
})

export const ContentStyled = styled(Dropdown.Content, {
  zIndex: 10,
  backgroundColor: '$bg1',
  borderRadius: '$sm',
  minWidth: 220,
  boxShadow: '$md',
  py: '$2',

  '&[data-state="open"]': {
    animation: `${fadeInTop} 100ms`,
  },

  '&[data-state="closed"]': {
    animation: `${fadeOutTop} 100ms`,
  },
})

export const SeparatorStyled = styled(Dropdown.Separator, {
  my: '$2',
  bgc: '$bg3',
  height: 1,
})

export const ItemStyled = styled(Dropdown.Item, {
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  height: 32,
  color: '$text1',
  fontSize: '$sm',
  lineHeight: '$sm',
  spaceX: 3,
  px: '$2',
  mx: '$2',

  borderRadius: '$sm',
  cursor: 'pointer',
  userSelect: 'none',

  '&:hover': { bgc: '$bg2' },

  '&:focus': { outline: 'none', bgc: '$bg2' },

  '&[data-disabled]': {
    cursor: 'not-allowed',
    opacity: 0.8,
    color: '$text2',
  },

  variants: {
    targetChildren: {
      true: {
        '& > *': {
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        },
      },
    },
    selected: {
      true: {
        bgc: '$bg2',
      },
    },
  },

  defaultVariants: {
    targetChildren: true,
  },
})
